import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  finishQuizQuestion,
  getAllMoodleQuiz,
  getMoodleQuizAttempsOverviews,
  getMoodleQuizDetails,
  getMoodleQuizReview,
  saveQuizAnswer,
  startMoodleQuizAttempt,
  submitQuizAnswer,
} from "../api/moodleQuizAndAssignApi";
import { handleApiError } from "../api/instanceApi";

export const useHandleQuiz = (params?: any) => {
  const queryClient = useQueryClient();

  const { data: moodleQuizzes, isLoading: isMoodleQuizzesLoading } = useQuery({
    queryKey: ["moodle-quizzes"],
    queryFn: () => getAllMoodleQuiz(),
    staleTime: 6000,
  });

  const { data: quizAttemptOverview, isLoading: isQuizAttempOverviewLoading } =
    useQuery({
      queryKey: ["attempt-overview", params],
      queryFn: () => getMoodleQuizAttempsOverviews(params),
      staleTime: 6000,
    });

  const { data: quizAttemptDetails, isLoading: isQuizAttemptDetailsLoading } =
    useQuery({
      queryKey: ["attempt-details", params],
      queryFn: () => getMoodleQuizDetails(params),
      staleTime: 6000,
      refetchOnWindowFocus: false,
    });

  const { data: quizAttemptReview, isLoading: isQuizAttemptReviewLoading } =
    useQuery({
      queryKey: ["attempt-review", params],
      queryFn: () => getMoodleQuizReview(params),
      staleTime: 6000,
      refetchOnWindowFocus: false,
    });

  const startQuizMutation = useMutation({
    mutationFn: (param: any) => startMoodleQuizAttempt(param),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["attempt-overview", params],
      });
    },
    onError: handleApiError,
  });

  const submitQuizAnswerMutation = useMutation({
    mutationFn: (params: any) => submitQuizAnswer(params),
    onError: handleApiError,
  });
  const saveQuizAnswerMutation = useMutation({
    mutationFn: (params: any) => saveQuizAnswer(params),
    onError: handleApiError,
  });

  const finishQuizMutation = useMutation({
    mutationFn: (params: any) => finishQuizQuestion(params),
    onError: handleApiError,
  });

  return {
    moodleQuizzes,
    quizAttemptOverview,
    quizAttemptDetails,
    quizAttemptReview,
    startQuiz: startQuizMutation.mutateAsync,
    submitAnswer: submitQuizAnswerMutation.mutate,
    saveAnswer: saveQuizAnswerMutation.mutate,
    finishQuiz: finishQuizMutation.mutateAsync,
    isQuizAttempOverviewLoading,
    isMoodleQuizzesLoading,
    isQuizAttemptDetailsLoading,
    isQuizAttemptReviewLoading,
  };
};
